import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Panel from 'components/Panel';
import Carousel from 'components/Carousel';
import ChannelList from 'screens/Collection/components/ChannelList';
import {
  getPanelProps,
  getTileCarouselProps,
  getPosterCarouselProps,
  callCollectionImpressionEvent,
  BREAKPOINTS,
} from 'helpers/ChannelHelper';
import CarouselTileTheme from 'screens/Collection/CarouselTile.css';

const ChannelPanel = props => {
  const { breakpoint, idx } = props;
  const updateVisibleSlides = (prevSlideIndex, nextSlideIndex, panel) => {
    // Called upon carousel click
    const { breakpoint, disableScroll, updateVisibleElements, visibleCollections } = props;
    const { allowScrollLock, carouselLimit } = BREAKPOINTS[breakpoint];

    if (allowScrollLock) {
      disableScroll({ disableScroll: true, bodyOnly: true });
    }

    // Call Collection Impression Event on Carousel Click
    callCollectionImpressionEvent(props);

    // Update new visible items
    const collectionLength = panel?.items?.totalItems ?? 0;
    const headline = panel?.headline;
    let firstSlideIdx = nextSlideIndex;
    let lastSlideIdx = nextSlideIndex + carouselLimit;
    if (lastSlideIdx > collectionLength) {
      lastSlideIdx = collectionLength;
      firstSlideIdx = collectionLength - carouselLimit;
    }
    const currentVisibleCollections = visibleCollections;
    const slideCollectionItems = panel?.items?.member;
    const slideRange = [
      Math.min(firstSlideIdx, lastSlideIdx),
      Math.max(firstSlideIdx, lastSlideIdx),
    ];
    const currentVisibleSlideItems = slideCollectionItems.slice(slideRange[0], slideRange[1]);
    currentVisibleSlideItems?.forEach((item, index) => {
      const slideItem = item;
      slideItem.slideIndex = index + slideRange[0];
    });
    if (currentVisibleCollections[headline]) {
      currentVisibleCollections[headline].items = currentVisibleSlideItems;
      currentVisibleCollections[headline].slideRange = slideRange;
    }
    updateVisibleElements(currentVisibleCollections);
  };

  const panelProps = getPanelProps(props);
  const getPanelRenderer = (panel, idx, breakpoint) => {
    const collectionLength = panel?.items?.totalItems ?? 0;
    const displayTemplate = panel?.displayTemplate;
    const carouselProps = { ...props, updateVisibleSlides };
    switch (displayTemplate) {
      case 'featured':
        return <Carousel {...getPosterCarouselProps(carouselProps)} data-test="web-carousel" />;
      case 'destination':
        return (
          <ChannelList
            breakpoint={breakpoint}
            collectionLength={collectionLength}
            panel={panel}
            verticalPosition={+(idx + 1)}
          />
        );
      default:
        return <Carousel {...getTileCarouselProps(carouselProps)} data-test="web-carousel" />;
    }
  };
  return (
    <div key={props?.panel.id}>
      <Panel
        key={`channel-panel-${props?.panel?.id}`}
        {...panelProps}
        renderer={panel => (
          <div key="tile-carousel">
            <div
              className={classNames([
                CarouselTileTheme.container,
                CarouselTileTheme.additionalPoster,
              ])}
            >
              {getPanelRenderer(panel, breakpoint, idx)}
            </div>
          </div>
        )}
      />
    </div>
  );
};

ChannelPanel.propTypes = {
  breakpoint: PropTypes.string,
  disableScroll: PropTypes.func,
  idx: PropTypes.number,
  updateVisibleElements: PropTypes.func,
  visibleCollections: PropTypes.shape({}),
};

export default ChannelPanel;
